import React from 'react';
import "../../../styles/Categories.css";
import { Link } from 'react-router-dom';

const CategoryItem = ({ 
  imageUrl, 
  title, 
  altText = "Card image",
  width = "80px",
  onClick,
  linkTo
}) => {
  return (
    <Link to={linkTo} onClick={onClick} >
    <div className="catCard" style={{ width }}>
      {imageUrl && (
        <div className="catCard-image">   
          <img 
            src={imageUrl} 
            alt={altText}
          />
          <div className="catCard-content">
        {title && <h3 className="catCard-title">{title}</h3>}
      </div>
        </div>
      )}
      
      </div>
    </Link>
  );
};

export default CategoryItem;